import Banner from "@components/Banner";
import Breadcrumbs from "@components/Breadcrumbs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import StayInspired from "@components/Home/StayInspired";
import Gallery from "@components/Wellness/Gallery";
import Intro from "@components/Wellness65/Intro";
import Facilities from "@components/Wellness65/Facilities";
import { usePageContext } from "@providers/PageProvider";
import { useRouteContext } from "@providers/RouteProvider";
import helper, { wellnessPage, wellnessPage65 } from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { pageData, hotel } = usePageContext();
  const banner = helper.formatBanner(pageData);
  const gallery: any = wellnessPage.formatGallery(pageData);
  const intro = wellnessPage.formatIntro(pageData);
  const facilities = wellnessPage65.formatFacilitesAndServices(pageData);
  const footer = helper.renderDetailsFooter(hotel);
  return (
    <div className="bg-black" data-scroll-container>
      <Header />
      <Banner image={_.get(banner, "image")} title={_.get(banner, "title")} />
      <Breadcrumbs data={router.breadcrumbs("facilities-service", { hotel })} />
      <Intro data={intro} />
      <Facilities data={facilities} />
      <Gallery data={gallery} />
      {/* <AdditionalInfo dagta /> */}
      {/* <Stories /> */}
      {/* <Offers /> */}
      <StayInspired />
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
          phone: footer.phone,
        }}
      />
    </div>
  );
};

export default View;
